import { BookingState } from './types';

export const bookingInitialState: BookingState = {
  currentBooking: null,
};
